(function($) {
    var $fn = $(".part_ui_switcher");

    $fn.on("click",".elm_body__item",function (e) {
        var el = $(this);
        $fn.find(".mod--active").removeClass("mod--active");
        el.addClass("mod--active");
    })
})(jQuery);